import _ from 'underscore';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import linkedinInfoTemplate from 'hbars!templates/linkedinInfo';
import template from 'hbars!templates/linkedInProfile';

Handlebars.registerPartial('linkedinInfo', linkedinInfoTemplate);

var LinkedInProfileView = Backbone.View.extend({

    events: {
        'click .js-clear-information': 'clearClicked'
    },

    initialize: function() {
        this.listenTo(this.model, 'change:linkedinInfo', this.render);
    },

    clearClicked: function() {
        this.model.set('linkedinProfile', '');
    },

    render: function() {
        var hasLinkedinInformation = !_.isEmpty(this.model.get('linkedinInfo'));
        var data = _.extend(this.model.toJSON(), {
            hasLinkedinInformation: hasLinkedinInformation
        });
        var html = template(data);
        this.$el.html(html);
        return this;
    }
});

export default LinkedInProfileView;

